import { render, staticRenderFns } from "./AcrescimoDescontoChips.vue?vue&type=template&id=3756fc87"
import script from "./AcrescimoDescontoChips.vue?vue&type=script&lang=js"
export * from "./AcrescimoDescontoChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports